const getLogLevel = () => {
    const level = (process.env.REACT_APP_LOG_LEVEL || "info").toLowerCase();
    const levels = {
        debug: 0,
        info: 1,
        warn: 2,
        error: 3,
        none: 4,
    };
    return levels[level] !== undefined ? levels[level] : 1; // Default to info
};

const currentLevel = getLogLevel();

const logger = {
    debug: (...args) => {
        if (currentLevel <= 0) console.log(...args);
    },
    info: (...args) => {
        if (currentLevel <= 1) console.info(...args);
    },
    warn: (...args) => {
        if (currentLevel <= 2) console.warn(...args);
    },
    error: (...args) => {
        if (currentLevel <= 3) console.error(...args);
    },
};

export default logger;
